import { useContext } from 'react';

import AuthContext from '../Context/AuthContext';

import { signOutFirebaseUser } from '../lib/firebaseClients';
import { getStoredSession, LOGOUT } from '../lib/Token';

const useHandleLogout = () => {
  const { setUser } = useContext(AuthContext);

  return async () => {
    const session = getStoredSession();

    if (session?.type) {
      await signOutFirebaseUser(session.type).catch(() => undefined);
    }

    LOGOUT();
    setUser(null);
  };
};

export default useHandleLogout;
